export enum IconTypes {
  Light,
  Dark,
  Primary,
  Secondary,
}
